import * as React from 'react'
import {
  Box,
  Card,
  CardContent,
  Grid
} from '@mui/material'
import { ButtonWithIcon } from 'components'
import CleaningServicesIcon from '@mui/icons-material/CleaningServices'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import { type ReactNode } from 'react'
export interface UsFilters {
  [key: string]: any
  page: number
  order_field: string
  order_direction: 'ASC' | 'DESC'
}

export interface UsFiltersProps {
  filters: UsFilters
  updateFilters: (filters: any) => void
  doFilter: () => Promise<void>
  cleanFilters: () => void
  children?: React.ReactNode
}

export const UsTableFilters: React.FC<UsFiltersProps> = ({ filters, updateFilters, doFilter, cleanFilters, children }) => {
  const handleFilterClick = (): void => {
    if (filters.page === 1) {
      doFilter().catch((reason) => { console.log(reason) })
    } else {
      updateFilters({ page: 1 })
    }
  }

  const handlerClean = (): void => { cleanFilters() }

  const handleKeyDown = (event: React.KeyboardEvent): void => {
    if (event.key === 'Enter') {
      handleFilterClick()
    }
  }

  const getFilterElements = (): ReactNode => { // If the field for the filter is already inside a grid, keep it that way, if it's not, put it in a grid with size 3
    return React.Children.map(children, (child) => {
      return React.isValidElement(child) && child.type === Grid ? child : (<Grid item xs={4}>{child}</Grid>)
    })
  }

  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      mb: 2,
      mt: 3
    }} onKeyDown={handleKeyDown}>
      <Card sx={{
        flex: 1,
        p: 1.5,
        borderRadius: 4
      }}>
        <CardContent>
          <Grid container spacing={2} alignItems={'center'}>
            {getFilterElements()}
          </Grid>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={9}/>
            <Grid item xs={1.5}>
              <ButtonWithIcon fullWidth={true} variant="contained" size='large' nameButton='Search'
                              icon={<FilterAltIcon/>} onClick={handleFilterClick}></ButtonWithIcon>
            </Grid>
            <Grid item xs={1.5}>
              <ButtonWithIcon fullWidth={true} variant="contained" size='large' nameButton='Clean'
                              icon={<CleaningServicesIcon/>} onClick={handlerClean}></ButtonWithIcon>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  )
}
